module.exports = __webpack_public_path__ + "img/HQ-ENC-C-V1.6a8f7673.jpg";